/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllZugaenge$Json } from '../fn/zugang/get-all-zugaenge-json';
import { GetAllZugaenge$Json$Params } from '../fn/zugang/get-all-zugaenge-json';
import { getAllZugaenge$Plain } from '../fn/zugang/get-all-zugaenge-plain';
import { GetAllZugaenge$Plain$Params } from '../fn/zugang/get-all-zugaenge-plain';
import { ZugangDto } from '../models/zugang-dto';

@Injectable({ providedIn: 'root' })
export class ZugangApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllZugaenge()` */
  static readonly GetAllZugaengePath = '/v1/zugaenge';

  /**
   * Holt alle Zugaenge.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllZugaenge$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZugaenge$Plain$Response(params?: GetAllZugaenge$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZugangDto>>> {
    return getAllZugaenge$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Zugaenge.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllZugaenge$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZugaenge$Plain(params?: GetAllZugaenge$Plain$Params, context?: HttpContext): Observable<Array<ZugangDto>> {
    return this.getAllZugaenge$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZugangDto>>): Array<ZugangDto> => r.body)
    );
  }

  /**
   * Holt alle Zugaenge.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllZugaenge$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZugaenge$Json$Response(params?: GetAllZugaenge$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZugangDto>>> {
    return getAllZugaenge$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Zugaenge.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllZugaenge$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllZugaenge$Json(params?: GetAllZugaenge$Json$Params, context?: HttpContext): Observable<Array<ZugangDto>> {
    return this.getAllZugaenge$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZugangDto>>): Array<ZugangDto> => r.body)
    );
  }

}
